export interface CountryListOptions {
  labels: string[];
  values: string[];
}

const countriesEs: CountryListOptions = {
  values: [
    'AF',
    'AL',
    'DE',
    'AD',
    'AO',
    'AI',
    'AG',
    'TF',
    'AN',
    'AQ',
    'SA',
    'DZ',
    'AR',
    'AM',
    'AW',
    'AC',
    'AU',
    'AT',
    'AZ',
    'BS',
    'BH',
    'BD',
    'BB',
    'BY',
    'BZ',
    'BJ',
    'BM',
    'BO',
    'BA',
    'BW',
    'BR',
    'BN',
    'BG',
    'BF',
    'BI',
    'BT',
    'BE',
    'CV',
    'KH',
    'CM',
    'CA',
    'QA',
    'TD',
    'CL',
    'CN',
    'CY',
    'CO',
    'KM',
    'CG',
    'KR',
    'CR',
    'CI',
    'HR',
    'CU',
    'CW',
    'DK',
    'DJ',
    'DM',
    'EC',
    'EG',
    'SV',
    'AE',
    'ER',
    'SK',
    'SI',
    'ES',
    'FM',
    'US',
    'EE',
    'ET',
    'PH',
    'FI',
    'FJ',
    'FR',
    'GA',
    'GM',
    'GE',
    'GH',
    'GI',
    'GD',
    'GR',
    'GL',
    'GP',
    'GU',
    'GT',
    'GF',
    'GQ',
    'GW',
    'GY',
    'HT',
    'HN',
    'HK',
    'HU',
    'IN',
    'ID',
    'IQ',
    'IE',
    'IM',
    'CX',
    'EI',
    'YT',
    'NF',
    'RE',
    'UM',
    'WF',
    'IS',
    'KY',
    'CC',
    'CK',
    'FK',
    'FO',
    'MP',
    'MH',
    'UM',
    'SB',
    'TC',
    'VG',
    'VI',
    'IL',
    'IT',
    'JM',
    'JP',
    'JO',
    'KZ',
    'KE',
    'KG',
    'KI',
    'XK',
    'KW',
    'LA',
    'LS',
    'LV',
    'LR',
    'LY',
    'LI',
    'LT',
    'LU',
    'LB',
    'MO',
    'MK',
    'MG',
    'MY',
    'MW',
    'MV',
    'MT',
    'ML',
    'MA',
    'MQ',
    'MU',
    'MR',
    'MD',
    'MN',
    'MS',
    'MZ',
    'MM',
    'MX',
    'MC',
    'NA',
    'NR',
    'NP',
    'NI',
    'NG',
    'NU',
    'NO',
    'NC',
    'NZ',
    'NE',
    'OM',
    'PK',
    'PW',
    'PA',
    'PG',
    'PY',
    'NL',
    'PE',
    'PF',
    'PL',
    'PT',
    'PR',
    'GB',
    'GN',
    'CF',
    'CZ',
    'DO',
    'RW',
    'RO',
    'RU',
    'SW',
    'AS',
    'KN',
    'SM',
    'MF',
    'PM',
    'VC',
    'ST',
    'SN',
    'RS',
    'SC',
    'SL',
    'SG',
    'VN',
    'SO',
    'LK',
    'SH',
    'LC',
    'ZA',
    'SE',
    'CH',
    'SR',
    'SZ',
    'TH',
    'TW',
    'TZ',
    'TJ',
    'TG',
    'TK',
    'TO',
    'TT',
    'TM',
    'TR',
    'TV',
    'TN',
    'UA',
    'UG',
    'UY',
    'UZ',
    'VU',
    'VA',
    'VE',
    'YE',
    'YU',
    'ZR',
    'ZM',
    'ZW',
  ],
  labels: [
    'Afganistán',
    'Albania',
    'Alemania',
    'Andorra',
    'Angola',
    'Anguila',
    'Antigua y Barbuda',
    'Antillas Francesas',
    'Antillas Neerlandesas',
    'Antártida',
    'Arabia Saudita',
    'Argelia',
    'Argentina',
    'Armenia',
    'Aruba',
    'Ascension',
    'Australia',
    'Austria',
    'Azerbaiyán',
    'Bahamas',
    'Bahrein',
    'Bangladesh',
    'Barbados',
    'Belarús',
    'Belice',
    'Benín',
    'Bermudas',
    'Bolivia',
    'Bosnia y Herzegovina',
    'Botsuana',
    'Brasil',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Bután',
    'Bélgica',
    'Cabo Verde',
    'Camboya',
    'Camerún',
    'Canada',
    'Catar',
    'Chad',
    'Chile',
    'China',
    'Chipre',
    'Colombia',
    'Comoras',
    'Congo',
    'Corea del Sur',
    'Costa Rica',
    'Costa de marfil',
    'Croacia',
    'Cuba',
    'Curazao',
    'Dinamarca',
    'Djibouti',
    'Dominica',
    'Ecuador',
    'Egipto',
    'El Salvador',
    'Emiratos Árabes Unidos',
    'Eritrea',
    'Eslovaquia',
    'Eslovenia',
    'España',
    'Estados Federados de Micronésia',
    'Estados Unidos',
    'Estonia',
    'Etiopía',
    'Filipinas',
    'Finlandia',
    'Fiyi',
    'Francia',
    'Gabón',
    'Gambia',
    'Georgia',
    'Ghana',
    'Gibraltar',
    'Granada',
    'Grecia',
    'Groenlandia',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guayana Francesa',
    'Guinea Ecuatorial',
    'Guinea-Bisáu',
    'Guiana',
    'Haiti',
    'Honduras',
    'Hong Kong',
    'Hungría',
    'India',
    'Indonesia',
    'Irak',
    'Irlanda',
    'Isla de Man',
    'Isla de Navidad',
    'Isla de Pascua',
    'Isla Mayotte',
    'Isla Norfolk',
    'Isla Reunion',
    'Isla Wake',
    'Isla Wallis Y Futuna',
    'Islandia',
    'Islas Caimán',
    'Islas Coco',
    'Islas Cook',
    'Islas Falkland',
    'Islas Feroe',
    'Islas Mariana',
    'Islas Marshall',
    'Islas Midway',
    'Islas Salomón',
    'Islas Turcas y Caicos',
    'Islas Vírgenes Británicas',
    'Islas Vírgenes de los Estados Unidos',
    'Israel',
    'Italia',
    'Jamaica',
    'Japón',
    'Jordania',
    'Kazajistán',
    'Kenia',
    'Kirguistán',
    'Kiribati',
    'Kosovo',
    'Kuwait',
    'Laos',
    'Lesoto',
    'Letonia',
    'Liberia',
    'Libia',
    'Liechtenstein',
    'Lituania',
    'Luxemburgo',
    'Líbano',
    'Macau',
    'Macedonia',
    'Madagascar',
    'Malasia',
    'Malaui',
    'Maldivas',
    'Malta',
    'Malí',
    'Marruecos',
    'Martinica',
    'Mauricio',
    'Mauritania',
    'Moldavia',
    'Mongolia',
    'Montserrat',
    'Mozambique',
    'Myanmar',
    'México',
    'Mónaco',
    'Namibia',
    'Nauru',
    'Nepal',
    'Nicaragua',
    'Nigeria',
    'Niue',
    'Noruega',
    'Nueva Caledonia',
    'Nueva Zelanda',
    'Níger',
    'Omán',
    'Pakistán',
    'Palau',
    'Panamá',
    'Papúa Nueva Guinea',
    'Paraguay',
    'Países Bajos',
    'Perú',
    'Polinesia Francesa',
    'Polonia',
    'Portugal',
    'Puerto Rico',
    'Reino Unido',
    'Rep Guinea',
    'República Centroafricana',
    'República Checa',
    'República Dominicana',
    'Ruanda',
    'Rumania',
    'Rusia',
    'Samoa',
    'Samoa Americana',
    'San Cristóbal y Nieves',
    'San Marino',
    'San Martín',
    'San Pedro y Miquelón',
    'San Vicente y las Granadinas',
    'Santo Tomé y Príncipe',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leona',
    'Singapur',
    'Soc Republic of Vietnam',
    'Somalia',
    'Sri Lanka',
    'St Helena',
    'St Lucia',
    'Sudáfrica',
    'Suecia',
    'Suiza',
    'Surinam',
    'Swazilandia',
    'Tailandia',
    'Taiwán',
    'Tanzania',
    'Tayikistán',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad y Tobago',
    'Turkmenistán',
    'Turquía',
    'Tuvalu',
    'Túnez',
    'Ucrania',
    'Uganda',
    'Uruguay',
    'Uzbekistán',
    'Vanuatu',
    'Vaticano',
    'Venezuela',
    'Yemen',
    'Yugoslavia',
    'Zaire',
    'Zambia',
    'Zimbabwe',
  ],
};

const countriesEn: CountryListOptions = {
  values: [
    'AF',
    'AL',
    'DZ',
    'AS',
    'AD',
    'AO',
    'AI',
    'AQ',
    'AG',
    'AR',
    'AM',
    'AW',
    'AC',
    'AU',
    'AT',
    'AZ',
    'BS',
    'BH',
    'BD',
    'BB',
    'BY',
    'BE',
    'BZ',
    'BJ',
    'BM',
    'BT',
    'GW',
    'BO',
    'BA',
    'BW',
    'BR',
    'VG',
    'BN',
    'BG',
    'BF',
    'BI',
    'KH',
    'CM',
    'CA',
    'CV',
    'KY',
    'CF',
    'TD',
    'CL',
    'CN',
    'CX',
    'CC',
    'CO',
    'KM',
    'CG',
    'CK',
    'CR',
    'HR',
    'CU',
    'CW',
    'CY',
    'CZ',
    'DK',
    'DJ',
    'DM',
    'DO',
    'EI',
    'EC',
    'EG',
    'SV',
    'GQ',
    'ER',
    'EE',
    'ET',
    'FK',
    'FO',
    'FM',
    'FJ',
    'FI',
    'FR',
    'TF',
    'GF',
    'PF',
    'GA',
    'GM',
    'GE',
    'DE',
    'GH',
    'GI',
    'GR',
    'GL',
    'GD',
    'GP',
    'GU',
    'GT',
    'GY',
    'HT',
    'HN',
    'HK',
    'HU',
    'IS',
    'IN',
    'ID',
    'IQ',
    'IE',
    'IM',
    'IL',
    'IT',
    'CI',
    'JM',
    'JP',
    'JO',
    'KZ',
    'KE',
    'KI',
    'XK',
    'KW',
    'KG',
    'LA',
    'LV',
    'LB',
    'LS',
    'LR',
    'LY',
    'LI',
    'LT',
    'LU',
    'MO',
    'MK',
    'MG',
    'MW',
    'MY',
    'MV',
    'ML',
    'MT',
    'MP',
    'MH',
    'MQ',
    'MR',
    'MU',
    'YT',
    'MX',
    'UM',
    'MD',
    'MC',
    'MN',
    'MS',
    'MA',
    'MZ',
    'MM',
    'NA',
    'NR',
    'NP',
    'AN',
    'NL',
    'NC',
    'NZ',
    'NI',
    'NE',
    'NG',
    'NU',
    'NF',
    'NO',
    'OM',
    'PK',
    'PW',
    'PA',
    'PG',
    'PY',
    'PE',
    'PH',
    'PL',
    'PT',
    'PR',
    'QA',
    'GN',
    'RS',
    'RE',
    'RO',
    'RU',
    'RW',
    'MF',
    'ST',
    'SM',
    'SA',
    'SN',
    'SC',
    'SL',
    'SG',
    'SK',
    'SI',
    'VN',
    'SB',
    'SO',
    'ZA',
    'KR',
    'ES',
    'LK',
    'SH',
    'KN',
    'LC',
    'PM',
    'VC',
    'SR',
    'SZ',
    'SE',
    'CH',
    'TW',
    'TJ',
    'TZ',
    'TH',
    'TG',
    'TK',
    'TO',
    'TT',
    'TN',
    'TR',
    'TM',
    'TC',
    'TV',
    'UG',
    'UA',
    'AE',
    'GB',
    'US',
    'UY',
    'VI',
    'UZ',
    'VU',
    'VA',
    'VE',
    'UM',
    'WF',
    'SW',
    'YE',
    'YU',
    'ZR',
    'ZM',
    'ZW',
  ],
  labels: [
    'Afghanistan',
    'Albania',
    'Algeria',
    'American Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antarctica',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Ascension',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benim',
    'Bermuda',
    'Bhutan',
    'Bissau Guinea',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'British Virgin Islands',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Cape Verde Islands',
    'Cayman Islands',
    'Central African Republic',
    'Chad Republic',
    'Chile',
    'China',
    'Christmas Island',
    'Cocos Islands',
    'Colombia',
    'Comoros',
    'Congo',
    'Cook Islands',
    'Costa Rica',
    'Croatia',
    'Cuba',
    'Curacao',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Easter Island',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equitorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fed States Micronesia',
    'Fiji Islands',
    'Finland',
    'France',
    'French Antilles',
    'French Guiana',
    'French Polynesia',
    'Gabon Republic',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada and Carriacuou',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Ivory Coast',
    'Jamaica',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Kosovo',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali Republic',
    'Malta',
    'Mariana Islands',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mayotte Island',
    'Mexico',
    'Midway Islands',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Neth Antilles',
    'Netherlands',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger Republic',
    'Nigeria',
    'Niue',
    'Norfolk Island',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Rep Guinea',
    'Republic of Serbia',
    'Reunion Island',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Martin',
    'Saint Thomas and Prince',
    'San Marino',
    'Saudi Arabia',
    'Senegal Republic',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Soc Republic of Vietnam',
    'Solomon Islands',
    'Somalia Republic',
    'South Africa',
    'South Korea',
    'Spain',
    'Sri Lanka',
    'St Helena',
    'St Kitts and Nevis',
    'St Lucia',
    'St Pierre et Miquelon',
    'St Vincent and the Grenadines',
    'Suriname',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks and Caicos Islands',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'Uruguay',
    'US Virgin Islands',
    'Uzbekistan',
    'Vanuatu',
    'Vatican City',
    'Venezuela',
    'Wake Island',
    'Wallis and Futuna Islands',
    'Western Samoa',
    'Yemen',
    'Yugoslavia',
    'Zaire',
    'Zambia',
    'Zimbabwe',
  ],
};

const countriesPt: CountryListOptions = {
  values: [
    'AF',
    'ZA',
    'AL',
    'DE',
    'AD',
    'AO',
    'AI',
    'TF',
    'AN',
    'AQ',
    'AG',
    'AR',
    'DZ',
    'AM',
    'AW',
    'SA',
    'AC',
    'AU',
    'AT',
    'AZ',
    'BS',
    'BH',
    'BD',
    'BB',
    'BZ',
    'BJ',
    'BM',
    'BY',
    'BO',
    'BW',
    'BR',
    'BN',
    'BG',
    'BF',
    'BI',
    'BT',
    'BE',
    'BA',
    'CV',
    'CM',
    'KH',
    'CA',
    'QA',
    'KZ',
    'TD',
    'CL',
    'CN',
    'CY',
    'CO',
    'CC',
    'KM',
    'CG',
    'KR',
    'CR',
    'CI',
    'HR',
    'CU',
    'CW',
    'DK',
    'DJ',
    'DM',
    'EG',
    'SV',
    'AE',
    'EC',
    'ER',
    'SK',
    'SI',
    'ES',
    'FM',
    'US',
    'EE',
    'ET',
    'FJ',
    'PH',
    'FI',
    'FR',
    'GA',
    'GH',
    'GE',
    'GI',
    'GD',
    'GL',
    'GR',
    'GP',
    'GU',
    'GT',
    'GF',
    'GN',
    'GQ',
    'GW',
    'GY',
    'GM',
    'HT',
    'NL',
    'HN',
    'HK',
    'HU',
    'IM',
    'CX',
    'EI',
    'UM',
    'NF',
    'RE',
    'UM',
    'KY',
    'CK',
    'FK',
    'FO',
    'MP',
    'MH',
    'YT',
    'SB',
    'TC',
    'VI',
    'VG',
    'WF',
    'IN',
    'ID',
    'IQ',
    'IE',
    'IS',
    'IL',
    'IT',
    'YE',
    'JM',
    'JP',
    'JO',
    'KI',
    'XK',
    'KW',
    'LA',
    'LS',
    'LV',
    'LR',
    'LI',
    'LT',
    'LU',
    'LB',
    'LY',
    'MO',
    'MK',
    'MG',
    'MV',
    'ML',
    'MT',
    'MY',
    'MW',
    'MA',
    'MQ',
    'MR',
    'MU',
    'MD',
    'MN',
    'MS',
    'MZ',
    'MM',
    'MX',
    'MC',
    'NA',
    'NR',
    'NP',
    'NI',
    'NE',
    'NG',
    'NU',
    'NO',
    'NC',
    'NZ',
    'OM',
    'PW',
    'PA',
    'PG',
    'PK',
    'PY',
    'PE',
    'PF',
    'PL',
    'PR',
    'PT',
    'KG',
    'KE',
    'GB',
    'CF',
    'DO',
    'CZ',
    'RO',
    'RW',
    'RU',
    'SW',
    'AS',
    'SM',
    'SH',
    'LC',
    'SN',
    'SL',
    'SC',
    'SG',
    'SO',
    'LK',
    'SZ',
    'SR',
    'SE',
    'CH',
    'KN',
    'MF',
    'PM',
    'ST',
    'VC',
    'RS',
    'TH',
    'TW',
    'TJ',
    'TZ',
    'TG',
    'TO',
    'TK',
    'TT',
    'TN',
    'TM',
    'TR',
    'TV',
    'UA',
    'UG',
    'UY',
    'UZ',
    'VU',
    'VA',
    'VE',
    'VN',
    'YU',
    'ZR',
    'ZW',
    'ZM',
  ],
  labels: [
    'Afeganistão',
    'África do Sul',
    'Albânia',
    'Alemanha',
    'Andorra',
    'Angola',
    'Anguila',
    'Antilhas Francesas',
    'Antilhas Holandesas',
    'Antártica',
    'Antígua e Barbuda',
    'Argentina',
    'Argélia',
    'Armênia',
    'Aruba',
    'Arábia Saudita',
    'Ascension',
    'Austrália',
    'Áustria',
    'Azerbaijão',
    'Bahamas',
    'Bahrein',
    'Bangladesh',
    'Barbados',
    'Belize',
    'Benim',
    'Bermudas',
    'Bielorrússia',
    'Bolívia',
    'Botsuana',
    'Brasil',
    'Brunei',
    'Bulgária',
    'Burkina Faso',
    'Burundi',
    'Butão',
    'Bélgica',
    'Bósnia e Herzegovina',
    'Cabo Verde',
    'Camarões',
    'Camboja',
    'Canadá',
    'Catar',
    'Cazaquistão',
    'Chade',
    'Chile',
    'China',
    'Chipre',
    'Colômbia',
    'Ilhas Cocos',
    'Comores',
    'Congo',
    'Coréia do Sul',
    'Costa Rica',
    'Costa do Marfim',
    'Croácia',
    'Cuba',
    'Curação',
    'Dinamarca',
    'Djubouti',
    'Dominica',
    'Egito',
    'El Salvador',
    'Emirados Árabes Unidos',
    'Equador',
    'Eritréia',
    'Eslováquia',
    'Eslovênia',
    'Espanha',
    'Estados Federados da Micronésia',
    'Estados Unidos',
    'Estônia',
    'Etiópia',
    'Fiji',
    'Filipinas',
    'Finlândia',
    'França',
    'Gabão',
    'Gana',
    'Geórgia',
    'Gibraltar',
    'Granada',
    'Groenlândia',
    'Grécia',
    'Guadalupe',
    'Guam',
    'Guatemala',
    'Guiana Francesa',
    'Guiné',
    'Guiné Equatorial',
    'Guiné-Bissau',
    'Guiana',
    'Gâmbia',
    'Haiti',
    'Holanda',
    'Honduras',
    'Hong Kong',
    'Hungria',
    'Ilha de Man',
    'Ilha de Natal',
    'Ilha de Páscoa',
    'Ilha Midway',
    'Ilha Norfolk',
    'Ilha Reunião',
    'Ilha Wake',
    'Ilhas Cayman',
    'Ilhas Cook',
    'Ilhas Falkland',
    'Ilhas Feroe',
    'Ilhas Mariana',
    'Ilhas Marshall',
    'Ilhas Mayotte',
    'Ilhas Salomão',
    'Ilhas Turks e Caicos',
    'Ilhas Virgens Americanas',
    'Ilhas Virgens Britânicas',
    'Ilhas Wallis e Futuna',
    'Índia',
    'Indonésia',
    'Iraque',
    'Irlanda',
    'Islândia',
    'Israel',
    'Itália',
    'Iêmen',
    'Jamaica',
    'Japão',
    'Jordânia',
    'Kitibati',
    'Kosovo',
    'Kuwait',
    'Laos',
    'Lesoto',
    'Letônia',
    'Libéria',
    'Liechtenstein',
    'Lituânia',
    'Luxemburgo',
    'Líbano',
    'Líbia',
    'Macau',
    'Macedônia',
    'Madagascar',
    'Maldivas',
    'Mali',
    'Malta',
    'Malásia',
    'Maláui',
    'Marrocos',
    'Martinica',
    'Mauritânia',
    'Maurício',
    'Moldávia',
    'Mongólia',
    'Montserrat',
    'Moçambique',
    'Myanmar',
    'México',
    'Mônaco',
    'Namíbia',
    'Nauru',
    'Nepal',
    'Nicarágua',
    'Niger',
    'Nigéria',
    'Niue',
    'Noruega',
    'Nova Caledônia',
    'Nova Zelândia',
    'Omã',
    'Palau',
    'Panamá',
    'Papua-Nova Guiné',
    'Paquistão',
    'Paraguai',
    'Peru',
    'Polinésia Francesa',
    'Polônia',
    'Porto Rico',
    'Portugal',
    'Quirguistão',
    'Quênia',
    'Reino Unido',
    'República Centro-Africana',
    'República Dominicana',
    'República Tcheca',
    'Romênia',
    'Ruanda',
    'Rússia',
    'Samoa',
    'Samoa americana',
    'San Marino',
    'Santa Helena',
    'Santa Lúcia',
    'Senegal',
    'Serra Leoa',
    'Seychelles',
    'Singapura',
    'Somália',
    'Sri Lanka',
    'Suazilândia',
    'Suriname',
    'Suécia',
    'Suíça',
    'São Cristóvão e Nevis',
    'São Martinho',
    'São Pedro e Miquelão',
    'São Tomé e Príncipe',
    'São Vicente e Granadinas',
    'Sérvia',
    'Tailândia',
    'Taiwan',
    'Tajiquistão',
    'Tanzânia',
    'Togo',
    'Tonga',
    'Toquelau',
    'Trindade e Tobago',
    'Tunísia',
    'Turcomenistão',
    'Turquia',
    'Tuvalu',
    'Ucrania',
    'Uganda',
    'Uruguai',
    'Uzbequistão',
    'Vanuatu',
    'Vaticano',
    'Venezuela',
    'Vietnã',
    'Yugoslavia',
    'Zaire',
    'Zimbabwe',
    'Zâmbia',
  ],
};

export const COUNTRY_OPTIONS = {
  en_US: countriesEn,
  pt_BR: countriesPt,
  es_ES: countriesEs,
};
